<agr-powerbi-report
  [workspaceId]="workspaceId"
  [reportId]="reportId"
  [baseEmbedConfig]="baseEmbedConfig"
></agr-powerbi-report>
